import React, { Component } from 'react';

import './Container.css';

export default class Container extends Component {
    render() {
        const transparent = this.props.transparent ? ' transparent ' : '';
        const fluid = this.props.fluid ? ' fluid ' : '';
        const grid = this.props.grid ? 'grid col-' + this.props.grid : '';
        const container = 'container ' + transparent + fluid + grid;

        return <div className={container}>{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/container/Container.jsx